module.exports = {
    header: undefined,
    body: undefined,
    isScrolling: undefined,
    startingPoint: 0,
    delta: 5,
    headerHeight: undefined,

    activateMobileHeaderAutoHide: function () {
        const self = this;
        self.header = $('[data-bind="mobile-header"]');
        self.body = $("body");
        self.headerHeight = self.header.outerHeight();
        $(window).scroll(function () {
            self.isScrolling = true
        });
        setInterval(function () {
            if (self.isScrolling) {
                self.manageScroll();
                self.isScrolling = false
            }
        }, 250);
    },

    manageScroll: function () {
        if(!$("body").hasClass('filter-bar--is-active')) {
            const self = this;
            const scrollTop = $(window).scrollTop();
            if (Math.abs(self.startingPoint - scrollTop) <= self.delta) {
                return
            }
            if (scrollTop > self.startingPoint && scrollTop > self.headerHeight) {
                self.body.removeClass("nav-down").addClass("nav-up")
            } else {
                if (scrollTop + $(window).height() < $(document).height()) {
                    self.body.removeClass("nav-up").addClass("nav-down")
                }
            }
            self.startingPoint = scrollTop;
        }
    }
};